import { useEffect } from 'react'
import { router } from '@inertiajs/react'

type EventNames = Parameters<typeof router.on>[0]

// Inertia router の event を購読する共通 hook。
// `router.on(event, handler)` の useEffect + return-unsubscribe パターンが ThemedRoot と
// useFlashNotifications で重複していたため、subscribe ライフサイクルを 1 箇所に集約する。
//
// handler は引数の関数を毎レンダで購読し直す挙動を避けるため、呼び出し側で useCallback
// 等で安定化させるか、無依存 (= 親 state を closure 経由で見ない) で書くこと。
// この hook 自体は handler を依存配列に含めない (Inertia の listener の付け外しは比較的
// 高価で頻繁にやりたくない & 開発者意図として「mount 中ずっと subscribe」を想定する)。
export function useRouterEvent<T extends EventNames>(
  event: T,
  handler: Parameters<typeof router.on<T>>[1],
) {
  useEffect(() => {
    return router.on(event, handler)
    // handler を依存に含めない (上記コメント参照)。event は通常リテラル定数。
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
